import { render, staticRenderFns } from "./layout-agent.vue?vue&type=template&id=94d51bce&scoped=true"
import script from "./layout-agent.vue?vue&type=script&lang=js"
export * from "./layout-agent.vue?vue&type=script&lang=js"
import style0 from "./layout-agent.vue?vue&type=style&index=0&id=94d51bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d51bce",
  null
  
)

export default component.exports